module.exports = __webpack_public_path__ + "static/media/corp_cf_4.947929ba.png";